import api from "../api";

// Property meters register.
//
// Meters belong to the property, not to an inspection report. They are added,
// corrected, replaced and removed from the Property page only -- an inspector
// filling in a monthly inspection supplies just the reading and a photo.
const propertyMetersService = {
  // Active meters for a property, ordered by type then id.
  getMetersByProperty: async (propertyId) => {
    return await api.get(`/property-meters/properties/${propertyId}`);
  },

  // Add a meter. Type, serial number and location are all mandatory.
  addMeter: async (propertyId, meterData) => {
    return await api.post(
      `/property-meters/properties/${propertyId}`,
      meterData
    );
  },

  // Correct an existing meter (typo in a serial, a vague location). The change
  // propagates to every report that displays it -- that is intended.
  updateMeter: async (meterId, meterData) => {
    return await api.put(`/property-meters/${meterId}`, meterData);
  },

  // The physical unit was swapped. Deactivates this meter and creates its
  // replacement, so reports from before the swap keep showing the original.
  replaceMeter: async (meterId, meterData) => {
    return await api.post(`/property-meters/${meterId}/replace`, meterData);
  },

  // Record that the property genuinely has no meters, so inspections are not
  // blocked by an empty register. Rejected by the API if meters exist.
  setNoMeters: async (propertyId, confirmed) => {
    return await api.put(`/property-meters/properties/${propertyId}/no-meters`, {
      no_meters_confirmed: confirmed,
    });
  },

  // Soft delete -- the meter stops appearing on new inspection reports while
  // historic reports still resolve it.
  removeMeter: async (meterId) => {
    return await api.delete(`/property-meters/${meterId}`);
  },
};

export default propertyMetersService;
